/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useRef, useState, useEffect } from "react";
import ChevronUpIcon from "assets/icons/chevron-up.svg";
import PinMarkerIcon from "assets/icons/pin-marker.svg";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import PinApprovalCard from "./PinApprovalCard.vue";
import PinClarifications from "./PinClarifications.vue";
import PinComposer from "./PinComposer.vue";
import PinEscalationCard from "./PinEscalationCard.vue";
import PinMessages from "./PinMessages.vue";

import PinningDisclaimer from "./PinningDisclaimer.vue";
import { PIN_COLORS } from "./composables/usePinningPanel";
import { cn } from "tailwind-variants";

export default function PinningPanel({
  isDesktop = false,
  panel,
  pendingInitialMessage = null,
  isMultiUpload: _isMultiUpload,
  isCompletingSession = false,
  onApprovePreview,
  onRejectPreview,
  onEscalationConfirm,
  onEscalationCancel,
  ...restProps
}: any) {
  const SCROLL_BEHAVIOR_SMOOTH = "smooth";
  const SCROLL_BLOCK_NEAREST = "nearest";

  const [disclaimerDismissed, setDisclaimerDismissed] = useState(false);
  const pinsContainerRef = useRef(null);
  const messagesScrollRef = useRef(null);
  const pinComposerRef = useRef(null);

  function pendingMessages() {
    return pendingInitialMessage
      ? [
          {
            id: "pending-initial",
            role: "user",
            content: pendingInitialMessage,
            timestamp: Date.now()
          }
        ]
      : [];
  }

  function activePinIndex() {
    if (!panel.activePin()) return -1;
    return panel.pins.findIndex((pin: any) => pin.id === panel.activePin().id);
  }

  function isActiveChat() {
    return (
      panel.activePin() &&
      panel.activePin().state !== "ready" &&
      panel.activePin().state !== "unsupported"
    );
  }

  function isCompletedPin(pin: any) {
    return pin.state === "ready" || pin.state === "unsupported";
  }

  function shouldShowEscalation(pin: any) {
    return (
      pin.state === "ready" && !(panel.previewApproval && panel.previewApproval.pinId === pin.id)
    );
  }

  function goBackToList() {
    panel.setMobileView("list");
    panel.setActivePinId(null);
  }

  function handlePinListClick(pin: any) {
    panel.trackPinSelected(pin.id, panel.activePinId, pin.state);
    panel.setActivePinId(pin.id);
    panel.setMobileView("detail");
  }

  function handleDesktopPinClick(pin: any) {
    if (
      panel.activePin() &&
      panel.activePin().state !== "ready" &&
      panel.activePin().state !== "unsupported"
    ) {
      return;
    }
    if (pin.id !== panel.activePinId) {
      panel.trackPinSelected(pin.id, panel.activePinId, pin.state);
    }
    panel.setActivePinId(pin.id === panel.activePinId ? null : pin.id);
  }

  function handleDeleteClick(pin: any) {
    if (isCompletedPin(pin)) {
      panel.openDeletePinModal(pin.id);
    } else {
      panel.handleDeletePin(pin.id);
    }
  }

  useEffect(() => {
    if (panel.activePinId && pinComposerRef.current) {
      // @ts-expect-error TS(2339): Property 'scrollIntoView' does not exist on type '... Remove this comment to see the full error message
      pinComposerRef.current.scrollIntoView({
        behavior: SCROLL_BEHAVIOR_SMOOTH,
        block: SCROLL_BLOCK_NEAREST
      });
    }
  }, [panel.activePinId, panel.activePin()?.messages?.length, panel.activePin()?.state]);

  useEffect(() => {
    if (panel.activePinId) {
      setDisclaimerDismissed(true);
    }
  }, [panel.activePinId]);

  return (
    <div
      {...restProps}
      className={cn("flex h-full flex-col overflow-hidden", isDesktop && "w-full max-w-[700px]")}
    >
      {!isDesktop ? (
        <div className="flex h-full flex-col overflow-hidden bg-white">
          {!disclaimerDismissed ? (
            <div className="shrink-0 px-2 pt-2">
              <PinningDisclaimer
                compact={true}
                onDismiss={() => {
                  setDisclaimerDismissed(true);
                }}
                data-testid="pinning-disclaimer"
              />
            </div>
          ) : null}
          <div className="min-h-0 flex-1 overflow-y-auto p-2">
            {panel.pins.length === 0 ? (
              <>
                {pendingInitialMessage ? (
                  <div className="flex flex-col overflow-hidden rounded-lg border border-blue-200 bg-blue-50/30">
                    <div className="flex shrink-0 items-center border-b border-blue-200 px-2 py-1.5">
                      <span className="text-xs font-semibold text-gray-900">
                        <span
                          style={{
                            color: PIN_COLORS[0]
                          }}
                        >
                          Pin 1
                        </span>
                        :{" "}
                        <span className="font-normal text-gray-500">
                          What would you like to do?
                        </span>
                      </span>
                    </div>
                    <div className="px-2 py-1.5">
                      <PinMessages
                        // @ts-expect-error TS(2322): Type '{ id: string; role: string; content: any; ti... Remove this comment to see the full error message
                        messages={pendingMessages()}
                        compact={true}
                        data-testid="pin-messages"
                      />
                    </div>
                    <div className="shrink-0 border-t border-blue-200 p-2">
                      <div className="flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-2 py-1.5">
                        <PinMarkerIcon
                          className="h-4 w-4 shrink-0 -rotate-45 text-blue-500"
                          data-testid="h-4"
                        />
                        <span className="text-xs text-blue-700">
                          {" "}
                          Please tap on the image where you would like the edit to be made{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex h-full flex-col items-center justify-center py-4 text-center text-gray-500">
                    <PinMarkerIcon
                      className="mb-3 h-12 w-12 -rotate-45 text-gray-300"
                      data-testid="mb-3"
                    />
                    <p className="m-0 max-w-[280px] text-sm leading-relaxed">
                      {" "}
                      No instructions added yet. Click anywhere on the image to drop a pin and add
                      instructions for our artists.{" "}
                    </p>
                  </div>
                )}
              </>
            ) : panel.mobileView === "detail" && panel.activePin() ? (
              <div
                className={cn(
                  "flex flex-col overflow-hidden rounded-lg border border-blue-200 bg-blue-50/30",
                  isActiveChat() && "h-full"
                )}
              >
                <div className="flex shrink-0 items-center justify-between border-b border-blue-200 px-2 py-1.5">
                  <div className="flex items-center gap-1 font-medium">
                    {isCompletedPin(panel.activePin()) ? (
                      <button
                        className="flex cursor-pointer rounded border-none bg-transparent p-0.5 text-gray-700 hover:bg-gray-100"
                        type="button"
                        data-testid="pin-back-button"
                        onClick={goBackToList}
                      >
                        <UseSvg className="h-3.5 w-3.5" icon="arrow-left" data-testid="h-3.5" />
                      </button>
                    ) : null}
                    <span className="text-sm font-semibold text-gray-900">
                      <span
                        style={{
                          color: PIN_COLORS[activePinIndex() % PIN_COLORS.length]
                        }}
                      >
                        {" "}
                        Pin {activePinIndex() + 1}
                      </span>
                      :{" "}
                      <span className="font-normal text-gray-500">What would you like to do?</span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    {isActiveChat() ? (
                      <button
                        className="flex cursor-pointer items-center rounded border-none bg-transparent p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                        type="button"
                        data-testid="pin-panel-expand-toggle"
                        aria-label={panel.isPanelExpanded ? "Collapse panel" : "Expand panel"}
                        onClick={() => {
                          panel.setIsPanelExpanded(!panel.isPanelExpanded);
                        }}
                      >
                        <ChevronUpIcon
                          className={cn(
                            "h-4 w-4 transition-transform",
                            panel.isPanelExpanded && "rotate-180"
                          )}
                          data-testid="h-4-2"
                        />
                      </button>
                    ) : null}
                    <button
                      className="flex cursor-pointer items-center rounded border-none bg-transparent p-1 text-gray-400 hover:bg-red-50 hover:text-red-500 disabled:cursor-not-allowed disabled:opacity-50"
                      type="button"
                      data-testid={`pin-delete-${panel.activePin().id}`}
                      aria-label={`Delete pin ${panel.activePin().id}`}
                      disabled={panel.removingPinIds.has(panel.activePin().id)}
                      onClick={() => {
                        handleDeleteClick(panel.activePin());
                      }}
                    >
                      {panel.removingPinIds.has(panel.activePin().id) ? (
                        <UseSvg
                          className="h-3.5 w-3.5 animate-spin"
                          icon="loader"
                          data-testid="h-3.5-1"
                        />
                      ) : (
                        <UseSvg className="h-3.5 w-3.5" icon="trash" data-testid="h-3.5-2" />
                      )}
                    </button>
                  </div>
                </div>

                <div className="min-h-0 flex-1 overflow-y-auto" ref={messagesScrollRef}>
                  {panel.activePin().messages.length > 0 ? (
                    <div className="px-2 py-1.5">
                      <PinMessages
                        messages={panel.activePin().messages}
                        isProcessing={panel.activePin().state === "processing"}
                        thinkingText={panel.activePin().thinkingText}
                        compact={true}
                        data-testid="pin-messages-1"
                      />
                    </div>
                  ) : null}
                  {panel.activePin().state === "needs_clarification" &&
                  panel.pendingPillClarifications().length > 0 ? (
                    <div className="px-2 pb-2">
                      <PinClarifications
                        clarifications={panel.pendingPillClarifications()}
                        responses={panel.clarificationResponses}
                        isDisabled={false}
                        textInfo={panel.lastAiMessageWithClarifications()?.textInfo}
                        selectedFont={panel.selectedFontValue()}
                        selectedColor={panel.selectedColorValue()}
                        unansweredAbove={panel.unansweredAbove}
                        unansweredBelow={panel.unansweredBelow}
                        compact={true}
                        onSelectOption={(q: any, v: any) =>
                          panel.handleSelectClarificationOption(q, v)
                        }
                        onToggleCustomInput={(q: any) => panel.handleToggleCustomInput(q)}
                        onCustomInputChange={(q: any, v: any) =>
                          panel.handleCustomInputChange(q, v)
                        }
                        onSubmit={() => {
                          panel.handleSubmit();
                        }}
                        onScroll={() => {
                          panel.calculateUnansweredPositions();
                        }}
                        onScrollToUnanswered={(dir: any) => panel.scrollToFirstUnanswered(dir)}
                        data-testid="pin-clarifications"
                      />
                    </div>
                  ) : null}
                </div>

                {panel.previewApproval && panel.previewApproval.pinId === panel.activePin().id ? (
                  <div className="shrink-0 border-t border-blue-200 p-2">
                    <PinApprovalCard
                      isApproving={panel.isApproving}
                      isRejecting={panel.isRejecting}
                      disabled={
                        panel.isApproving ||
                        panel.isRejecting ||
                        (panel.previewApproval && !panel.isPreviewImageLoaded)
                      }
                      compact={true}
                      onApprove={() => onApprovePreview?.()}
                      onReject={() => onRejectPreview?.()}
                      data-testid="pin-approval-card"
                    />
                  </div>
                ) : null}

                {shouldShowEscalation(panel.activePin()) ? (
                  <div className="shrink-0 border-t border-blue-200 p-2">
                    <PinEscalationCard
                      isConfirming={isCompletingSession}
                      isCancelling={panel.removingPinIds.has(panel.activePin().id)}
                      compact={true}
                      onConfirm={() => onEscalationConfirm?.()}
                      onCancel={() => onEscalationCancel?.(panel.activePin().id)}
                      data-testid="pin-escalation-card"
                    />
                  </div>
                ) : null}

                {!isCompletedPin(panel.activePin()) &&
                !(panel.previewApproval && panel.previewApproval.pinId === panel.activePin().id) ? (
                  <div className="shrink-0 border-t border-blue-200 p-2">
                    <PinComposer
                      modelValue={panel.composerText}
                      canSubmit={
                        panel.hasAnyClarificationResponse() ||
                        panel.isComposerTextValid(panel.composerText)
                      }
                      isProcessing={panel.activePin().state === "processing"}
                      isRemoving={panel.removingPinIds.has(panel.activePin().id)}
                      compact={true}
                      onUpdateModelValue={(val: any) => {
                        panel.setComposerText(val);
                      }}
                      onSubmit={() => {
                        panel.handleSubmit();
                      }}
                      onCancel={() => {
                        panel.handleDeletePin(panel.activePin().id);
                      }}
                      onNewline={(pos: any) => {
                        panel.setPendingCursorPosition(pos);
                      }}
                      onTextareaRef={(el: any) => {
                        panel.textareaRef.current = el;
                      }}
                      data-testid="pin-composer"
                    />
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
                {panel.pins.map((pin: any, index: any) => (
                  <div
                    className="flex cursor-pointer items-start justify-between gap-2 rounded-lg border border-gray-200 bg-white p-2.5 transition-colors hover:bg-gray-50"
                    key={pin.id}
                    onClick={() => {
                      handlePinListClick(pin);
                    }}
                    data-testid="flex"
                  >
                    <div className="min-w-0 flex-1">
                      <span
                        className="text-xs font-semibold"
                        style={{
                          color: PIN_COLORS[index % PIN_COLORS.length]
                        }}
                      >
                        {" "}
                        Pin {index + 1}
                      </span>
                      {pin.instruction && pin.state === "ready" ? (
                        <p className="mt-1 truncate text-sm text-gray-700">{pin.instruction}</p>
                      ) : (
                        <p className="mt-1 text-sm text-gray-500">
                          {isCompletedPin(pin) ? "Completed" : "What would you like to do?"}
                        </p>
                      )}
                    </div>
                    <div className="flex items-center gap-1">
                      <button
                        className="flex cursor-pointer items-center rounded border-none bg-transparent p-1 text-gray-400 hover:bg-red-50 hover:text-red-500 disabled:cursor-not-allowed disabled:opacity-50"
                        type="button"
                        data-testid={`pin-delete-list-${pin.id}`}
                        disabled={panel.removingPinIds.has(pin.id)}
                        onClick={e => {
                          e.stopPropagation();
                          handleDeleteClick(pin);
                        }}
                      >
                        {panel.removingPinIds.has(pin.id) ? (
                          <UseSvg
                            className="h-4 w-4 animate-spin"
                            icon="loader"
                            data-testid="h-4-3"
                          />
                        ) : (
                          <UseSvg className="h-4 w-4" icon="trash" data-testid="h-4-4" />
                        )}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto p-4" ref={pinsContainerRef}>
          {!disclaimerDismissed ? (
            <PinningDisclaimer
              onDismiss={() => {
                setDisclaimerDismissed(true);
              }}
              data-testid="pinning-disclaimer-2"
            />
          ) : null}
          {panel.pins.length === 0 ? (
            <>
              {pendingInitialMessage ? (
                <div className="flex flex-col gap-3 rounded-lg border border-blue-200 bg-blue-50/30 p-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-gray-900">
                      <span
                        style={{
                          color: PIN_COLORS[0]
                        }}
                      >
                        Pin 1
                      </span>
                      :{" "}
                      <span className="font-normal text-gray-500">What would you like to do?</span>
                    </span>
                  </div>
                  {/* @ts-expect-error TS(2322): Type '{ id: string; role: string; content: any; ti... Remove this comment to see the full error message */}
                  <PinMessages messages={pendingMessages()} data-testid="pin-messages-2" />
                  <div className="flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2">
                    <PinMarkerIcon
                      className="h-5 w-5 shrink-0 -rotate-45 text-blue-500"
                      data-testid="h-5"
                    />
                    <span className="text-sm text-blue-700">
                      {" "}
                      Please click on the image where you would like the edit to be made{" "}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex h-full flex-col items-center justify-center text-center text-gray-500">
                  <PinMarkerIcon
                    className="mb-4 h-16 w-16 -rotate-45 text-gray-300"
                    data-testid="mb-4"
                  />
                  <p className="m-0 max-w-[280px] text-sm leading-relaxed">
                    {" "}
                    No instructions added yet. Click anywhere on the image to drop a pin and add
                    instructions for our artists.{" "}
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-col gap-4 pb-4">
              {panel.pins.map((pin: any, index: any) => (
                <div
                  className={cn(
                    "flex flex-col gap-3 rounded-lg border bg-white p-4 transition-colors",
                    pin.id === panel.activePinId
                      ? "border-blue-200 bg-blue-50/30"
                      : "border-gray-200"
                  )}
                  key={pin.id}
                  data-pin-id={pin.id}
                  onMouseEnter={() => {
                    if (isCompletedPin(pin)) {
                      panel.setHoveredPinId(pin.id);
                      panel.setHoveredPinSource("panel");
                    }
                  }}
                  onMouseLeave={() => {
                    if (isCompletedPin(pin)) {
                      panel.setHoveredPinId(null);
                      panel.setHoveredPinSource(null);
                    }
                  }}
                  data-testid="flex-1"
                >
                  <div className="flex items-center justify-between">
                    <div
                      className="flex cursor-pointer items-center gap-2 font-medium"
                      onClick={() => {
                        handleDesktopPinClick(pin);
                      }}
                      data-testid="flex-2"
                    >
                      <span className="text-sm font-semibold text-gray-900">
                        <span
                          style={{
                            color: PIN_COLORS[index % PIN_COLORS.length]
                          }}
                        >
                          {" "}
                          Pin {index + 1}
                        </span>
                        :{" "}
                        <span className="font-normal text-gray-500">
                          What would you like to do?
                        </span>
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        className="flex cursor-pointer items-center rounded border-none bg-transparent p-1 text-gray-400 hover:bg-red-50 hover:text-red-500 disabled:cursor-not-allowed disabled:opacity-50"
                        type="button"
                        data-testid={`pin-delete-${pin.id}`}
                        disabled={panel.removingPinIds.has(pin.id)}
                        onClick={() => {
                          handleDeleteClick(pin);
                        }}
                      >
                        {panel.removingPinIds.has(pin.id) ? (
                          <UseSvg
                            className="h-4 w-4 animate-spin"
                            icon="loader"
                            data-testid="h-4-5"
                          />
                        ) : (
                          <UseSvg className="h-4 w-4" icon="trash" data-testid="h-4-6" />
                        )}
                      </button>
                    </div>
                  </div>

                  {pin.messages.length > 0 ? (
                    <div className="flex flex-col gap-4">
                      <PinMessages
                        messages={pin.messages}
                        isProcessing={pin.state === "processing"}
                        thinkingText={pin.thinkingText}
                        data-testid="pin-messages-3"
                      />
                    </div>
                  ) : null}
                  {pin.id === panel.activePinId &&
                  panel.previewApproval &&
                  panel.previewApproval.pinId === pin.id ? (
                    <PinApprovalCard
                      isApproving={panel.isApproving}
                      isRejecting={panel.isRejecting}
                      disabled={
                        panel.isApproving ||
                        panel.isRejecting ||
                        (panel.previewApproval && !panel.isPreviewImageLoaded)
                      }
                      onApprove={() => onApprovePreview?.()}
                      onReject={() => onRejectPreview?.()}
                      data-testid="pin-approval-card-1"
                    />
                  ) : null}

                  {pin.id === panel.activePinId && shouldShowEscalation(pin) ? (
                    <PinEscalationCard
                      isConfirming={isCompletingSession}
                      isCancelling={panel.removingPinIds.has(pin.id)}
                      onConfirm={() => onEscalationConfirm?.()}
                      onCancel={() => onEscalationCancel?.(pin.id)}
                      data-testid="pin-escalation-card-1"
                    />
                  ) : null}

                  {pin.id === panel.activePinId &&
                  !isCompletedPin(pin) &&
                  !(panel.previewApproval && panel.previewApproval.pinId === pin.id) ? (
                    <div
                      className={cn("scroll-mb-4", pin.messages.length > 0 && "mt-2")}
                      ref={pinComposerRef}
                    >
                      {pin.state === "needs_clarification" &&
                      panel.pendingPillClarifications().length > 0 ? (
                        <PinClarifications
                          clarifications={panel.pendingPillClarifications()}
                          responses={panel.clarificationResponses}
                          isDisabled={pin.state === "processing"}
                          textInfo={panel.lastAiMessageWithClarifications()?.textInfo}
                          selectedFont={panel.selectedFontValue()}
                          selectedColor={panel.selectedColorValue()}
                          unansweredAbove={panel.unansweredAbove}
                          unansweredBelow={panel.unansweredBelow}
                          onSelectOption={(q: any, v: any) =>
                            panel.handleSelectClarificationOption(q, v)
                          }
                          onToggleCustomInput={(q: any) => panel.handleToggleCustomInput(q)}
                          onCustomInputChange={(q: any, v: any) =>
                            panel.handleCustomInputChange(q, v)
                          }
                          onSubmit={() => {
                            panel.handleSubmit();
                          }}
                          onScroll={() => {
                            panel.calculateUnansweredPositions();
                          }}
                          onScrollToUnanswered={(dir: any) => panel.scrollToFirstUnanswered(dir)}
                          data-testid="pin-clarifications-1"
                        />
                      ) : null}
                      <PinComposer
                        modelValue={panel.composerText}
                        canSubmit={
                          panel.hasAnyClarificationResponse() ||
                          panel.isComposerTextValid(panel.composerText)
                        }
                        isProcessing={pin.state === "processing"}
                        isRemoving={panel.removingPinIds.has(pin.id)}
                        onUpdateModelValue={(val: any) => {
                          panel.setComposerText(val);
                        }}
                        onSubmit={() => {
                          panel.handleSubmit();
                        }}
                        onCancel={() => {
                          handleDeleteClick(pin);
                        }}
                        onNewline={(pos: any) => {
                          panel.setPendingCursorPosition(pos);
                        }}
                        onTextareaRef={(el: any) => {
                          panel.textareaRef.current = el;
                        }}
                        data-testid="pin-composer-1"
                      />
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

PinningPanel.displayName = "PinningPanel";
